import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { InvestmentPropertyService } from '../../../../modules/investment/property/investment-property.service';
import { InvestmentPropertyModel } from '../../../../modules/investment/property/investment-property.model';
import { ensureOk } from '../../../finance/entity-form/entity-form.utils';
import { SearchPayload } from '../../../shared/utils/table-types';
import { InvestmentListResult, requestInvestmentList } from '../../shared/investment-list.util';
import { SummaryRealStateInvestmentListModel, SummaryRealStateInvestmentModel } from '../models/summary-real-state-investment.model';

const LIST_ERROR = 'No se pudo cargar la lista de inversiones inmobiliarias';

@Injectable({ providedIn: 'root' })
export class RealStateInvestmentEntityService {

  constructor(private http: HttpClient, private propertyService: InvestmentPropertyService) { }

  list(payload: SearchPayload): Promise<InvestmentListResult<SummaryRealStateInvestmentModel, SummaryRealStateInvestmentListModel>> {
    return requestInvestmentList<SummaryRealStateInvestmentModel, SummaryRealStateInvestmentListModel>(this.http, '/api/v2/real-state-investments/list', payload, LIST_ERROR);
  }

  get(uid: string): Promise<InvestmentPropertyModel> {
    return this.propertyService.get(uid).then(investment => {
      if (!investment) throw new Error();
      return investment;
    });
  }

  create(payload: InvestmentPropertyModel): Promise<void> {
    return this.propertyService.add(payload).then(ensureOk);
  }

  update(uid: string, payload: InvestmentPropertyModel): Promise<void> {
    return this.propertyService.edit({ ...payload, uid }).then(ensureOk);
  }
}
